import React, { useState, useContext } from "react";
import { TbCircleCheck } from "react-icons/tb";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import ButtonUI from "../../material-ui/ButtonUI";
import { AuthContext } from "../../../context/Auth/AuthContext";
import approveRequestedCase from "../../../api/approveRequestedCase";

/*** Component for approving the document from the pdf viewer ***/
const ApprovePDFDocumentPopup = ({
  documentId,
  documentRequestId,
  setReqStatus,
  setDocumentViewer,
  setDocumentUpdatedToTrue,
  setApproveConfirmOpen,
  currentTabId,
  closeTabById,
  refetchDocumentTable,
}) => {
  const [open, setOpen] = useState(true);
  const [approveLoading, setApproveLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setApproveConfirmOpen(false);
  };

  const onApproveDocumentFormSubmit = async () => {
    setApproveLoading(true);

    try {
      const approveCaseFormResponse = await approveRequestedCase({
        token: token,
        doc_id: documentId,
        doc_req_id: documentRequestId,
      });

      if (approveCaseFormResponse?.code === 200) {
        setOpen(false);
        showSuccess("Document is approved successfully");
        setReqStatus("Approved");

        if (setDocumentViewer) {
          setDocumentViewer(false);
        }

        if (setDocumentUpdatedToTrue) {
          setDocumentUpdatedToTrue();
        }

        if (refetchDocumentTable) {
          refetchDocumentTable();
        }

        if (currentTabId) {
          closeTabById(currentTabId);
        }

        setApproveConfirmOpen(false);
      } else {
        setOpen(false);
        showError("Error while approving the document");
        setApproveConfirmOpen(false);
      }
    } catch (error) {
      console.error(error);
      showError("Something went wrong");
    } finally {
      setApproveLoading(false); // ✅ always stop loading
    }
  };
  return (
    <div className="dialog-modal">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <TbCircleCheck />
          </div>
          <div className="popup-header-title">Approve Document</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to approve this document ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            loading={approveLoading}
            disabled={approveLoading}
            style={{
              margin: "15px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onApproveDocumentFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ApprovePDFDocumentPopup;
